















































import Vue from 'vue';
import AppMain from '@/components/AppMain.vue';
import AppEmpty from '@/components/AppEmpty.vue';
import AppPanel from '@/components/AppPanel.vue';
import AppPanelItem from '@/components/AppPanelItem.vue';
import AppListCoop from '@/components/AppListCoop.vue';
import AppListItem from '@/components/AppListItem.vue';
import COOPS from '@/graphql/queries/Coops.graphql';
import COOP_DELETE from '@/graphql/mutations/CoopDelete.graphql';
import {
  CoopDeleteMutation,
  CoopDeleteMutationVariables,
  CoopsQuery,
} from '@/types/schema';

export default Vue.extend({
  name: 'AdminCoops',
  components: {
    AppMain,
    AppEmpty,
    AppPanel,
    AppPanelItem,
    AppListCoop,
    AppListItem,
  },
  data() {
    return {
      coops: [] as CoopsQuery['coops'],
    };
  },
  methods: {
    async deleteCoop(id: string) {
      if (!id) return;
      if (!confirm("Are you sure? This action can't be undone.")) return;

      try {
        await this.$apollo.mutate<
          CoopDeleteMutation,
          CoopDeleteMutationVariables
        >({
          mutation: COOP_DELETE,
          variables: {
            input: { id },
          },
        });
        this.$apollo.queries.coops.refetch();
        this.$notify({
          text: 'Co-op deleted!',
          type: 'success',
          duration: 6000,
        });
      } catch (error) {
        this.$notify({
          text: error.graphQLErrors[0].message,
          type: 'error',
          duration: 6000,
        });
      }
    },
  },
  apollo: {
    coops: {
      query: COOPS,
      fetchPolicy: 'cache-and-network',
    },
  },
});
